export const testimonials = [
  {
    id: 1,
    type: 'text',
    name: 'Mehmet Yılmaz',
    location: 'İstanbul → München',
    rating: 5,
    text: 'Töle Lojistik ile 2 yıldır çalışıyorum. Türkiye\'den Almanya\'ya her taşımada son derece güvenilir ve zamanında teslimat yapıyorlar. Eşyalarım hiç hasar görmeden ulaştı, teşekkürler!',
    avatar: '/media/search-image-a500372a7f.jpg',
    date: 'Aralık 2024',
  },
  {
    id: 2,
    type: 'whatsapp',
    name: 'Ayşe Demir',
    location: 'Ankara → Frankfurt',
    rating: 5,
    text: 'Serkan bey çok ilgili ve profesyonel. WhatsApp\'tan 7/24 ulaşabiliyorsunuz, hızlıca cevap veriyor. Ev eşyalarımı Almanya\'ya taşıttım, hiç sorun yaşamadım. Kesinlikle tavsiye ederim!',
    avatar: '/media/search-image-e75180fadc.jpg',
    date: 'Ocak 2025',
  },
  {
    id: 3,
    type: 'instagram',
    name: 'HasanKaya_deu',
    location: 'İzmir → Köln',
    rating: 5,
    text: 'Arkadaşlar bu firma çok iyi! Aylarca araştırdım Türkiye-Almanya taşımacılığı için. Hem fiyatı makul hem de hizmet kalitesi çok yüksek. Parsiyel gönderi yaptım, sorunsuz geldi 🙏',
    avatar: '/media/search-image-e937a247d2.jpg',
    date: 'Şubat 2025',
  },
  {
    id: 4,
    type: 'text',
    name: 'Klaus Müller',
    location: 'Hamburg → Bursa',
    rating: 5,
    text: 'Sehr zuverlässig und pünktlich! Töle Lojistik hat meine Sendung von Hamburg nach Bursa ohne Probleme geliefert. Der Service ist ausgezeichnet und die Kommunikation sehr gut. Empfehle ich gerne weiter!',
    avatar: '/media/search-image-e937a247d2.jpg',
    date: 'Mart 2025',
  },
  {
    id: 5,
    type: 'whatsapp',
    name: 'Fatma Şahin',
    location: 'Bursa → Berlin',
    rating: 5,
    text: 'Almanya\'ya taşındım ve çok stresliydim. Serkan bey süreç boyunca beni her adımda bilgilendirdi. Fiyat teklifini anında aldım, eşyalarım tam zamanında ve hasarsız geldi. Allah razı olsun!',
    avatar: '/media/search-image-e75180fadc.jpg',
    date: 'Mart 2025',
  },
  {
    id: 6,
    type: 'instagram',
    name: 'emre_almanya34',
    location: 'İstanbul → Stuttgart',
    rating: 5,
    text: 'Töle Lojistik\'i tavsiye etmeden geçemezdim. 3 kutu parsiyel gönderisi yaptım Stuttgart\'a. Hem hızlıydı hem de fiyatı diğer firmalardan çok daha uygundu. WhatsApp\'tan takip ettim her şeyi!',
    avatar: '/media/search-image-e937a247d2.jpg',
    date: 'Nisan 2025',
  },
];
